export const columnOptions = [
  {
    label: 'ID',
    props: 'username'
  },
  {
    label: 'commons.nick_name',
    props: 'nickName'
  },
  {
    label: 'user.source',
    props: 'from'
  },
  {
    label: 'commons.email',
    props: 'email'
  },
  {
    label: 'commons.organization',
    props: 'dept'
  },
  {
    label: 'commons.role',
    props: 'roles'
  },
  {
    label: 'commons.status',
    props: 'status'
  },
  {
    label: 'commons.create_time',
    props: 'createTime'
  }
]
